<template>
  <div class="merchants-container">
    <el-card class="filter-card">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="商家名称">
          <el-input v-model="filterForm.name" placeholder="请输入商家名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div class="table-header">
        <div class="header-left">
          <span class="title">商家列表</span>
          <span class="count">共 {{ totalItems }} 条</span>
        </div>
        <div class="header-right">
          <el-button type="success" icon="el-icon-plus" @click="addMerchant">新增商家</el-button>
        </div>
      </div>
      
      <el-table
        :data="merchantList"
        border
        v-loading="tableLoading"
        style="width: 100%">
        <template slot="empty">
          <div class="empty-block">
            <p class="empty-text">{{ tableLoading ? '加载中...' : '暂无数据' }}</p>
          </div>
        </template>
        <el-table-column
          type="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="商家名称"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="contactPerson"
          label="联系人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="130">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status === 1 ? '正常' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="200">
          <template slot-scope="scope">
            <div class="operation-buttons">
              <el-button size="mini" type="primary" @click="editMerchant(scope.row)">编辑</el-button>
              <el-button size="mini" type="warning" @click="resetPassword(scope.row)">重置密码</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="pageSize"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>

    <merchant-form
      :visible.sync="formVisible"
      :is-edit="isEdit"
      :merchant-data="currentMerchant"
      @success="handleFormSuccess"
    />
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'
import MerchantForm from './MerchantForm.vue'

export default {
  name: 'Merchants',
  components: {
    MerchantForm
  },
  data() {
    return {
      filterForm: {
        name: '',
        status: ''
      },
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      merchantList: [],
      formVisible: false,
      isEdit: false,
      currentMerchant: {}
    }
  },
  created() {
    this.fetchMerchants()
  },
  methods: {
    async fetchMerchants() {
      this.tableLoading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          companyName: this.filterForm.name,
          status: this.filterForm.status || null
        }
        const res = await adminApi.getMerchantListByPage(params)
        if (res.data.code === 200) {
          this.merchantList = Array.isArray(res.data.data) ? res.data.data : []
          this.totalItems = res.data.count || 0
        } else {
          this.merchantList = []
          this.totalItems = 0
          this.$message.error(res.msg || '获取商家列表失败')
        }
      } catch (error) {
        this.merchantList = []
        this.totalItems = 0
        this.$message.error(error.msg || '获取商家列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.fetchMerchants()
    },
    resetFilter() {
      this.filterForm = {
        name: '',
        status: ''
      }
      this.handleFilter()
    },
    handleSizeChange() {
      this.fetchMerchants()
    },
    handleCurrentChange() {
      this.fetchMerchants()
    },
    getStatusType(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status] || 'info'
    },
    addMerchant() {
      this.isEdit = false
      this.currentMerchant = {}
      this.formVisible = true
    },
    editMerchant(row) {
      this.isEdit = true
      this.currentMerchant = { ...row }
      this.formVisible = true
    },
    resetPassword(row) {
      this.$confirm(`确定要重置商家 ${row.companyName} 的密码吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await adminApi.resetMerchantPassword(row.id)
          this.$message.success(`商家 ${row.companyName} 的密码已重置`)
        } catch (error) {
          this.$message.error(error.msg || '重置密码失败')
        }
      }).catch(() => {})
    },
    handleFormSuccess() {
      this.fetchMerchants()
    }
  }
}
</script>

<style scoped>
.merchants-container {
  padding: 20px 0;
}

.filter-card {
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.table-card {
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.count {
  color: #909399;
  font-size: 14px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.empty-block {
  padding: 30px 0;
  text-align: center;
}

.empty-text {
  color: #909399;
  font-size: 14px;
}

.operation-buttons {
  display: flex;
  gap: 8px;
}
</style> 